import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CargoStatus__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["CargoStatus", _ctx.cargoStatusClasses])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.status.title || _ctx.status.name), 1),
    _createElementVNode("i", {
      class: _normalizeClass(["CargoStatus__icon fa-lg ml-2", _ctx.iconClass])
    }, null, 2)
  ], 2))
}